import React from "react";

import { Col } from "react-bootstrap";
import parse from "html-react-parser";

import Shield from "assets/images/coming-soon/shield-done.png";
import SendMoney from "assets/images/coming-soon/send-money.png";
import SecureCard from "assets/images/coming-soon/secure-card.png";
import { formatTitleWithItalic } from "utils";

function MyAlrajhiImportance({ data }) {
  const icons = [Shield, SendMoney, SecureCard];
  
  return (
    <div className="importance">
      <div className="inward-container container">
        <div data-aos="fade-up" data-aos-delay="150">
          <h1 className="heading">Why use MY alrajhi?</h1>
        </div>
        <div className="d-flex flex-column flex-lg-row my-5">
          {data?.importance?.map((item, index) => (
            <Col
              className="d-flex flex-column align-items-center mx-5"
              data-aos="fade-up"
              data-aos-delay="150"
              key={index}
            >
              <div className="coming-soon-image-container">
                <img
                  src={item?.image || item?.image_link}
                  alt="Shield Icon"
                  className="d-block"
                  width="100%"
                />
              </div>
              <div>
                <h6>{formatTitleWithItalic(item.name)}</h6>
                {item.description && <p>{parse(item.description)}</p>}
              </div>
            </Col>
          ))}
          {/* <Col className="d-flex flex-column align-items-center mx-5"
                data-aos="fade-up"
                data-aos-delay="150"
            >
                <div className="image-container">
                    <img
                        src={SendMoney}
                        alt="Send Money Icon"
                        className="d-block"
                        width="100%"
                    />
                </div>
                <div>
                    <h6>Bank on the go and send money instantly</h6>
                    <p>Keep track of your transactions and see all your activities with detailed information</p>
                </div>
            </Col>
            <Col className="d-flex flex-column align-items-center mx-5"
                data-aos="fade-right"
                data-aos-delay="150"
            >
                <div className="image-container">
                    <img
                        src={SecureCard}
                        alt="Secure Card Icon"
                        className="d-block"
                        width="100%"
                    />
                </div>
                <div>
                    <h6>Secure credit card controls</h6>
                    <p>Misplaced your card? Lock it from the app to keep others from using it. If yor card is found, you can unlock it just as fast.</p>
                </div>
            </Col> */}
        </div>
        <iframe
          data-aos="fade-up"
          data-aos-delay="150"
          className="video-player"
          src={data?.videoLink}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  );
}

export default MyAlrajhiImportance;
